module.exports = "/_next/static/images/step3-6e7b6f31c3b659a88073d1bbe9ef56e7.png";